import RewardList from './reward.list';

export default {
  list: RewardList,
  create: false,
  show: false,
  edit: false,
};
